import { z } from 'zod';

export type TemplateInput = z.infer<typeof templateSchema>;

export const templateSchema = z.object({
  id: z.number().int().positive().optional(),
  name: z.string().min(1, 'Name is required').max(80),
  content: z.custom<unknown>(),
});
